import httpClient from "./http-client";

const ENDPOINT = "/configuracion/distancia";

export interface DistanciaCreateDto {
  id?: number;
  nombre: string;
}

class DistanciaService {
  getAll(): Promise<DistanciaCreateDto[]> {
    return httpClient.get(ENDPOINT).then(response => {
      if (response.data) {
        return response.data;
      }
    });
  }
  save(createDto: DistanciaCreateDto) {
    return httpClient.post(ENDPOINT, createDto);
  }
}
export default new DistanciaService();
